// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","headerContainer":"DZcvJ","banner":"_3xuwn","header":"_20Guu","headingTitle":"_2c726","headingSubtitle":"_3w0k1","downArrow":"_1qn_O"};